import React from "react"
import DfbHeadline from "../ui-kit/dfb_headline"
import DfbParagraph from "../ui-kit/dfb_paragraph"

const MUserPanel = ({ topline, headline, description, errorMessage, children }) => {
  return (
    <div className="m-UserPanel">
      <div className="m-UserPanel-wrapper">
        <div className="m-UserPanel-container">
          {(topline || headline || description || errorMessage) && (
            <div className="m-UserPanel-header">
              {topline && <div className="m-UserPanel-topline">{topline}</div>}

              {headline && (
                <DfbHeadline
                  headline={headline}
                  headline_level="h3"
                  add_class="m-UserPanel-headline"
                />
              )}

              {description && (
                <DfbParagraph
                  text={description}
                  add_class="m-UserPanel-description"
                />
              )}

              {errorMessage && (
                <DfbParagraph
                  text={errorMessage}
                  add_class="m-UserPanel-error-message"
                />
              )}
            </div>
          )}

          <div className="m-UserPanel-body">{children}</div>
        </div>
      </div>
    </div>
  )
}

export default MUserPanel
